var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay"},[_c('ZyroButton',{staticClass:"overlay__button",attrs:{"theme":"editor"},on:{"click":function($event){return _vm.$emit('edit-post')}}},[_vm._v(" "+_vm._s(_vm.$t('common.editPost'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }